import React, { InputHTMLAttributes } from "react";
import {
  CheckboxWrapper,
  CustomCheckboxStyles,
  CustomCheckboxStylesItem,
  HiddenInput,
  TextStyles,
} from "./styledCheckbox.styles";
import { useSelector } from "react-redux";
import { selectOnlineOrdersConfigs } from "../../../store/kitchen/kitchen.selector";
import { getColor } from "../../../utils/utils.common";
import { WhiteAndBlack } from "../../../utils/colorContrast/colorContrast";
import { useTextColor } from "../../../utils/colorContrast/useColorContrast";
import { useMediaQuery } from "@mui/material";

interface StyledCheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "type"> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
}

const StyledCheckbox: React.FC<StyledCheckboxProps> = ({
  checked,
  onChange,
  label = "",
  disabled = false,
  className = "",
  id,
  ...props
}) => {
  const onlineOrdersConfig = useSelector(selectOnlineOrdersConfigs);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const headerModalBackground = getColor(
    "header-modal-background",
    onlineOrdersConfig
  );
  const textBody = getColor("text-body", onlineOrdersConfig);
  const backgroundSecondary = getColor(
    "background-secondary",
    onlineOrdersConfig
  );

  const themeColor = useTextColor(headerModalBackground);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (!disabled) {
      onChange(e.target.checked);
    }
  };

  const containerStyles: React.CSSProperties = {
    display: "flex",
    gap: "8px",
    cursor: disabled ? "not-allowed" : "pointer",
    userSelect: "none",
    opacity: disabled ? 0.6 : 1,
    position: "relative",
  };

  return (
    <label style={containerStyles} className={className}>
      <CheckboxWrapper>
        <HiddenInput
          type="checkbox"
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          {...props}
        />
        <CustomCheckboxStyles
          textBody={textBody}
          backgroundSecondary={backgroundSecondary}
        >
          <CustomCheckboxStylesItem checked={checked} textBody={textBody}>
            {isMobile ? (
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.6667 1.5L4.25 7.91667L1.33333 5"
                  stroke={
                    themeColor === WhiteAndBlack.black ? "white" : "black"
                  }
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="14"
                height="11"
                viewBox="0 0 14 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.6001 1.8L4.90015 9.5L1.40015 6"
                  stroke={
                    themeColor === WhiteAndBlack.black ? "white" : "black"
                  }
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </CustomCheckboxStylesItem>
        </CustomCheckboxStyles>
      </CheckboxWrapper>
      <TextStyles disabled={disabled}>{label}</TextStyles>
    </label>
  );
};

export default StyledCheckbox;
